import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import useScrollTo from '../hooks/useScrollTo'
import './Header.css'

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const location = useLocation()
  const scrollToSection = useScrollTo()

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  return (
    <header className="header">
      <div className="wrapper">
        <div className="site-title">
          <Link to="/" title="The Golden Bridges Foundation">
            <span className="logo"></span>
            <span className="title-text">The Golden Bridges Foundation</span>
          </Link>
        </div>
        
        <button 
          className={`menu-toggle ${isMenuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle navigation menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`site-nav ${isMenuOpen ? 'active' : ''}`}>
          <ul className="nav-menu">
            <li className={location.pathname === '/' ? 'current-menu-item' : ''}>
              <Link to="/">Home</Link>
            </li>
            <li className={`menu-item-has-children ${location.pathname === '/about' ? 'current-menu-item' : ''}`}>
              <Link to="/about">About</Link>
              <ul className="sub-menu">
                <li><a href="/about#mission" onClick={(e) => { e.preventDefault(); scrollToSection('mission', '/about') }}>Mission</a></li>
                <li><a href="/about#history" onClick={(e) => { e.preventDefault(); scrollToSection('history', '/about') }}>History</a></li>
                <li><a href="/about#founder" onClick={(e) => { e.preventDefault(); scrollToSection('founder', '/about') }}>Founder</a></li>
                <li><a href="/about#values" onClick={(e) => { e.preventDefault(); scrollToSection('values', '/about') }}>Golden Rules</a></li>
                <li><a href="/about#team" onClick={(e) => { e.preventDefault(); scrollToSection('team', '/about') }}>Team</a></li>
                <li><a href="/about#financials" onClick={(e) => { e.preventDefault(); scrollToSection('financials', '/about') }}>Financials</a></li>
                <li><a href="/about#contact" onClick={(e) => { e.preventDefault(); scrollToSection('contact', '/about') }}>Contact Us</a></li>
              </ul>
            </li>
            <li>
              <a href="/#programs" onClick={(e) => { e.preventDefault(); scrollToSection('programs', '/') }}>Programs</a>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  )
}

export default Header